import { createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { CssBaseline } from '@mui/material'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { ThemeProvider } from 'styled-components'
import { IntlProvider } from 'react-intl'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { SnackbarProvider } from 'notistack'
import languages from 'languages'
import { flattenMessages } from 'utils/flattenMessages'
import materialUITheme from 'theme/materialUITheme'
import { selectLocale } from 'store/locale/slice'
import { renderRoutes } from 'routes'

export const router = createBrowserRouter(createRoutesFromElements(renderRoutes()))

export default function App(): JSX.Element {
  const locale = useSelector(selectLocale)
  const selectedLanguage = locale.language.code

  // Missing translations are an error by default. We demote them to a warning.
  const handleIntlProviderError = (err: any) => {
    if (err.code === 'MISSING_TRANSLATION') {
      // TODO: Fix missing translations so we can log warnings
      // console.warn('Missing translation', err.message)
      return
    }
    throw err
  }

  return (
    <IntlProvider
      locale={selectedLanguage}
      messages={flattenMessages(languages[selectedLanguage])}
      onError={handleIntlProviderError}
    >
      <MuiThemeProvider theme={materialUITheme('light')}>
        <ThemeProvider theme={materialUITheme('light')}>
          <CssBaseline />
          <DndProvider backend={HTML5Backend}>
            <SnackbarProvider>
              <RouterProvider router={router} />
            </SnackbarProvider>
          </DndProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </IntlProvider>
  )
}
